
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.384","height":"4.726","stroke":"#816cc2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"inherit","stroke-linecap":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"data-name":"Line 3","d":"M1.056 1.056l3.135 2.613"}}),_c('path',{attrs:{"data-name":"Line 4","d":"M7.326 1.056L4.191 3.669"}})])])
          )
        }
      }
    